<template>
  <v-container fluid>
    <page-header showBackButton></page-header>

    <v-card class="mb-8">
      <v-card-text>
        <v-form ref="basicForm" @submit.prevent>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" lg="4">
              <form-select
                label="type"
                :fieldValue.sync="formData.type"
                :options="$addonTypeOptions"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-select
                label="companyType"
                :fieldValue.sync="formData.company_type"
                :options="$companyTypeOptions"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-select
                label="status"
                :fieldValue.sync="formData.status"
                :options="$statusOptions"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-input
                label="nameZh"
                :fieldValue.sync="formData.name_zh"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-input
                label="nameEn"
                :fieldValue.sync="formData.name_en"
              />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-input
                label="price"
                :fieldValue.sync="formData.price"
                type="number"
                prefix="HK$"
                required
              />
            </v-col>
            <v-col cols="12" class="my-4">
              <v-tabs
                class="mb-2"
                v-model="contentTab"
                :height="40"
                active-class="tab-active"
                hide-slider
              >
                <v-tab :disabled="$store.getters.isLoading">{{ $t('contentZh') }}</v-tab>
                <v-tab :disabled="$store.getters.isLoading">{{ $t('contentEn') }}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="contentTab">
                <v-tab-item transition="fade-transition">
                  <quill-editor :html.sync="formData.content_zh" editorID="editorContentZh" />
                </v-tab-item>
                <v-tab-item transition="fade-transition">
                  <quill-editor :html.sync="formData.content_en" editorID="editorContentEn" />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
            <v-col cols="12">
              <image-uploader 
                :fileValue.sync="formData.icon"
                label="uploadIcon"
                fileType="image"
                inputRef="upload_icon"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <div class="d-flex align-center">
      <v-btn class="mt-2" :loading="$store.getters.isLoading" color="primary" @click="save()">{{ $t('save') }}</v-btn>
      <v-btn v-if="id !== null" class="mt-2 ml-2" :loading="$store.getters.isLoading" color="error" @click="handleDelete()">{{ $t('delete') }}</v-btn>
    </div>
   
    <confirm-dialog ref="confirmDeleteDialog" />
  </v-container>
</template>

<script>
import FormInput from '@/components/form/FormInput.vue';
import FormSelect from '@/components/form/FormSelect.vue';
import ImageUploader from '@/components/form/ImageUploader.vue';
import QuillEditor from '@/components/form/QuillEditor.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  name: 'AddonDetail',
  components: {
    FormInput,
    FormSelect,
    ImageUploader,
    QuillEditor,
    ConfirmDialog
  },
  computed: {
    id() {
      const id = parseInt(this.$route.params.id)
      if (!isNaN(id)) {
        return id
      }

      return null
    }
  },
  data: vm => ({
    contentTab: 0,
    formData: {
      status: 'active',
      type: '',
      company_type: '',
      name_zh: '',
      name_en: '',
      price: '',
      icon: '',
      content_zh: '',
      content_en: ''
    },

    ciTypeOptions: [
      { value: 'normal', text: vm.$t('addonServiceTypeOptions.normal') },
      { value: 'electronic', text: vm.$t('addonServiceTypeOptions.electronic') },
    ],
    articlesTypeOptions: [
      { value: 'normal', text: vm.$t('addonServiceTypeOptions.normal') },
      { value: 'electronic', text: vm.$t('addonServiceTypeOptions.electronic') },
      { value: 'x', text: vm.$t('addonServiceTypeOptions.unitBook') },
    ],
    greenBoxTypeOptions: [
      { value: 'normal', text: vm.$t('addonServiceTypeOptions.normal') },
      { value: 'electronic', text: vm.$t('addonServiceTypeOptions.electronic') },
      { value: 'x', text: vm.$t('addonServiceTypeOptions.price') },
    ]
  }),
  methods: {
    async getAddon() {
      try {
        const data = await this.$Fetcher.GetAddonById(this.id);
        for (let key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key];
          }
        }
      } catch (err) {
        this.$common.error(err);
        this.$store.dispatch('setAlert',{
          message: 'noData',
          redirect: 'AddonList'
        })
      } finally {
        this.$store.dispatch('setInitLoading', false);
      }
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const valid = await this.$refs['basicForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', {
          message: 'required',
        })
        return
      }

      this.$store.dispatch('setLoading', true);
      let payload = {
        status: this.formData.status,
        type: this.formData.type,
        company_type: this.formData.company_type,
        name_zh: this.formData.name_zh,
        name_en: this.formData.name_en,
        price: parseFloat(this.formData.price),
        icon: this.formData.icon,
        content: this.formData.content_zh,
        content_zh: this.formData.content_zh,
        content_en: this.formData.content_en,
      };

      if (this.$validate.DataValid(this.id)) {
        try {
          await this.$Fetcher.UpdateAddon(this.id, payload);
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
              type: 'success',
              message: 'message.saveSuccess',
              refresh: true
          })
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setAlert',{
            title: 'message.saveFail',
            message: err,
            type: 'error',
          })
        }
      } else {
        try {
          await this.$Fetcher.NewAddon(payload);
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            type: 'success',
            message: 'message.saveSuccess',
            redirect: 'AddonList',
          })
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setAlert',{
            title: 'message.saveFail',
            message: err,
            type: 'error',
          })
        }
      }
    },

    async handleDelete() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const confirm = await this.$refs['confirmDeleteDialog'].show();
      if (confirm) {
          this.$store.dispatch('setLoading', true);

          try {
            await this.$Fetcher.DeleteAddon(this.id);
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('setDataIsUpdated', false)
            this.$store.dispatch('toggleSnack', {
              type: 'success',
              message: 'message.saveSuccess',
              redirect: 'AddonList',
            })
          } catch (err) {
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('setAlert',{
              title: 'message.saveFail',
              message: err,
              type: 'error',
            })
          }
      }
    }
  },

  async mounted() {
    this.$store.dispatch('setInitLoading', true);
    if (this.$validate.DataValid(this.id)) { // edit
      this.getAddon()
    } else { // new
      this.$store.dispatch('setInitLoading', false);
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-tabs {
  box-shadow: none !important;
}
</style>
